(function() {
'use strict';

angular
    .module('TR')
    .service('sortCriteria', sortCriteria);

function sortCriteria(resourceService, $location, hotelCriteria, flightCriteria, dealsCriteria) {
    const service = {
        getHotelCriteria,
        getFlightCriteria,
        getDealsCriteria,
        saveSort,
        getSort,
        translateHotelSort,
        getHotelSortValueById
    };

    function processCriteria(values, criteria) {
        let itemCriteria = {
            name: resourceService.getDeferred(criteria.name),
            val: criteria.val,
            oneWay: criteria.oneWay,
            translatedKey: criteria.name,
            trackingLabel: criteria.name
        };
        if (criteria.defaultSort) {
            itemCriteria.defaultSort = criteria.defaultSort;
        }
        if (criteria.defaultOrder) {
            itemCriteria.defaultOrder = criteria.defaultOrder;
        }
        if (criteria.ascSuffix) {
            itemCriteria.ascSuffix = resourceService.getDeferred(criteria.ascSuffix);
        }
        if (criteria.descSuffix) {
            itemCriteria.descSuffix = resourceService.getDeferred(criteria.descSuffix);
        }

        values.push(itemCriteria);

        return values;
    }

    const processedHotelCriteria = [];

    for (let i in hotelCriteria) {
        processCriteria(processedHotelCriteria, hotelCriteria[i]);
    }

    if (TRPCONFIG.Domain.ReviewsEnabled) {
        processedHotelCriteria.splice(1, 0, {
            name: resourceService.getDeferred('CUSTOMERRATING'),
            val: [2],
            trackingLabel: 'CUSTOMERRATING'
        });
    }

    const processedFlightCriteria = [];

    for (let ii in flightCriteria) {
        processCriteria(processedFlightCriteria, flightCriteria[ii]);
    }

    const processedDealsCriteria = [];

    for (let iii in dealsCriteria) {
        processCriteria(processedDealsCriteria, dealsCriteria[iii]);
    }

    function getHotelCriteria() {
        return processedHotelCriteria;
    }

    function getFlightCriteria(oneWay) {
        if (oneWay === true) {
            return processedFlightCriteria.filter(function(c) {
                return c.oneWay;
            });
        }
        return processedFlightCriteria;
    }

    function translateHotelSort(criteriaValue) {
        if (!criteriaValue) { return {}; }
        const criteria = _.find(
            processedHotelCriteria,
            hc => angular.isArray(hc.val) ? (_.get(hc, 'val') || []).indexOf(criteriaValue) > -1 : _.get(hc, 'val') === criteriaValue
        );
        const defaultDir = _.get(criteria, 'defaultOrder');
        const otherDir = defaultDir === 'asc' ? 'desc' : 'asc';
        const translated = { label: criteria.translatedKey };
        if (defaultDir) {
            _.set(
                translated,
                'direction',
                _.get(criteria, 'defaultSort') === criteriaValue ? defaultDir : otherDir
            );
        }
        return translated;
    }

    function getDealsCriteria(criteria = undefined) {
        if (criteria) {
            return _.find(processedDealsCriteria, dc => dc.val.indexOf(criteria) > -1);
        }
        return processedDealsCriteria;
    }

    function saveSort(sortCriteria) {
        $location.search('sort', sortCriteria).replace();
    }

    function getSort() {
        const sort = _.get($location.search(), 'sort');
        return sort ? parseInt(sort) : undefined;
    }

    function getHotelSortValueById(id) {
        const sortObj = getHotelCriteria().filter(el => {
            return el.val.indexOf(id) !== -1;
        });
        return _.get(sortObj, '[0].trackingLabel');
    }

    return service;
}
})();
